import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'isRepeatedInput',
    'calendar',
    'repeatTypeInput',
    'repeatEveryField',
    'repeatEveryInput',
    'inputText',
    'scheduleType',
    'fixedScheduleWrapper',
    'mandatoryAttendance'
  ]

  connect() {
    if (this.hasRepeatTypeInputTarget) {
      this.updateRepeatEveryInputText(this.repeatTypeInputTarget.value)
    }
    if (this.hasScheduleTypeTarget) {
      this.updateScheduleWrapper(this.scheduleTypeTarget.value)
    }
    if (this.hasIsRepeatedInputTarget) {
      const repeatedTrueRadio = this.element.querySelector("[id$='_is_repeated_true']")
      this.updateRepeatTypeAppearance(repeatedTrueRadio?.checked)
    }

    if (document.getElementById('visit_visit_type')) {
      this.shiftEnabled = this.hasShift()
    }
  }

  handleisRepeatedInputChange({ target }) {
    this.updateRepeatTypeAppearance(target.value === 'true')
  }

  updateRepeatTypeAppearance(isRepeated) {
    this.element.querySelectorAll('.repeat-field').forEach(el => el.style.display = 'none')

    if (isRepeated) {
      this.element.querySelectorAll('.not-custom-schedule').forEach(el => el.style.display = '')
      this.updateCalendarAppearance(this.repeatTypeInputTarget.value)
    } else {
      this.clearAllRepeatingValues()
    }
  }

  handleRepeatTypeInputChange({ target }) {
    this.updateCalendarAppearance(target.value)
    this.updateRepeatEveryInputText(this.repeatTypeInputTarget.value)
  }

  updateCalendarAppearance(repeatType) {
    this.element.querySelectorAll('.repeat-field').forEach(el => el.style.display = 'none')

    if (repeatType === 'other') {
      this.element.querySelectorAll('.custom-schedule').forEach(el => el.style.display = '')
      this.clearSomeRepeatingValues()
    } else {
      this.element.querySelectorAll('.not-custom-schedule').forEach(el => el.style.display = '')
    }
  }

  updateRepeatEveryInputText(value) {
    switch (value) {
      case 'weekly':
        this.inputTextTarget.textContent = 'week(s)'
        break
      case 'monthly':
        this.inputTextTarget.textContent = 'month(s)'
        break
      default:
        this.inputTextTarget.textContent = 'day(s)'
    }
  }

  onScheduleTypeChange({ target }) {
    this.updateScheduleWrapper(target.value)
  }

  updateScheduleWrapper(value) {
    this.element.querySelectorAll('.schedule-wrapper').forEach(el => el.style.display = 'none')

    if (value === 'flexible') {
      if (this.hasShift()) {
        const shiftOption = document.querySelector("#visit_visit_type option[value='shift']")
        shiftOption?.remove()
      }
      this.element.querySelectorAll('.flexible').forEach(el => el.style.display = '')
      this.clearAllRepeatingValues()
      const repeatedFalseRadio = this.element.querySelector("[id$='is_repeated_false']")
      repeatedFalseRadio?.click()
    } else {
      // We remove shift as a visit type option at line 87 because we don't support flexible-shift visits. If the schedule changes back to fixed,
      // then we only want to reinsert the shift option if it was present at first
      if (this.shiftEnabled) this.addShiftToOptions()
      this.element.querySelectorAll('.fixed').forEach(el => el.style.display = '')
    }
  }

  addShiftToOptions() {
    var shift = document.createElement('option')
    shift.value = 'shift'
    shift.text = 'Shift'
    document.getElementById('visit_visit_type').add(shift, null)
  }

  hasShift() {
    const visitType = document.getElementById('visit_visit_type')
    const options = Array.apply(null, visitType.options)

    return options.filter(option => option.value === 'shift').length === 1
  }

  clearSomeRepeatingValues() {
    this.clearRepeatUntil(null)

    this.repeatEveryInputTarget.value = ''
  }

  clearRepeatUntil(date) {
    window.dispatchEvent(new CustomEvent('react-date-time:force-change', { detail: { id: 'repeat_until', date } }))
  }

  clearAllRepeatingValues() {
    if (this.hasIsRepeatedInputTarget) {
      this.repeatTypeInputTarget.value = ''
      this.clearSomeRepeatingValues()
    }
    if (this.hasMandatoryAttendanceTarget) {
      this.mandatoryAttendanceTarget.checked = false
    }
  }
}
